import { create } from 'zustand'

export const CPT_IMAGE_ACCEPT = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/webp': ['.webp'],
}

type BatchUploadDropState = {
  pendingFiles: File[] | null
  openWithFiles: (files: File[]) => void
  clearPendingFiles: () => void
}

export const useBatchUploadDropStore = create<BatchUploadDropState>((set) => ({
  pendingFiles: null,
  openWithFiles: (files) => set({ pendingFiles: files }),
  clearPendingFiles: () => set({ pendingFiles: null }),
}))
